import {
    GET_VOUCHER_LISTING,
    GET_VOUCHER_LISTING_SUCCESS,
    GET_VOUCHER_LISTING_FAIL,
    GET_VOUCHER_DETAILS,
    GET_VOUCHER_DETAILS_SUCCESS,
    GET_VOUCHER_DETAILS_FAIL,
    ADD_VOUCHER,
    ADD_VOUCHER_SUCCESS,
    ADD_VOUCHER_FAIL,
    UPDATE_VOUCHER,
    UPDATE_VOUCHER_SUCCESS,
    UPDATE_VOUCHER_FAIL,
    DELETE_VOUCHER,
    DELETE_VOUCHER_SUCCESS,
    DELETE_VOUCHER_FAIL,
    EXPORT_VOUCHER,
    EXPORT_VOUCHER_SUCCESS,
    EXPORT_VOUCHER_FAIL,
    RESET_VOUCHER_STATE,
    RESET_VOUCHER_ATTACHMENT_STATE,
} from "./actionTypes";

export const getVoucherListing = (voucher) => ({
    type: GET_VOUCHER_LISTING,
    payload: voucher,
});

export const getVoucherListingSuccess = voucher => ({
    type: GET_VOUCHER_LISTING_SUCCESS,
    payload: voucher,
});

export const getVoucherListingFail = error => ({
    type: GET_VOUCHER_LISTING_FAIL,
    payload: error,
});

export const getVoucherDetails = voucherId => ({
    type: GET_VOUCHER_DETAILS,
    payload: voucherId,
});

export const getVoucherDetailsSuccess = voucher => ({
    type: GET_VOUCHER_DETAILS_SUCCESS,
    payload: voucher,
});

export const getVoucherDetailsFail = error => ({
    type: GET_VOUCHER_DETAILS_FAIL,
    payload: error,
});

export const createVoucher = voucher => ({
    type: ADD_VOUCHER,
    payload: voucher,
});

export const createVoucherSuccess = voucher => ({
    type: ADD_VOUCHER_SUCCESS,
    payload: voucher,
});

export const createVoucherFail = error => ({
    type: ADD_VOUCHER_FAIL,
    payload: error,
});

export const updateVoucher = voucher => ({
    type: UPDATE_VOUCHER,
    payload: voucher,
});

export const updateVoucherSuccess = voucher => ({
    type: UPDATE_VOUCHER_SUCCESS,
    payload: voucher,
});

export const updateVoucherFail = error => ({
    type: UPDATE_VOUCHER_FAIL,
    payload: error,
});

export const deleteVoucher = voucherId => ({
    type: DELETE_VOUCHER,
    payload: voucherId,
});

export const deleteVoucherSuccess = voucherId => ({
    type: DELETE_VOUCHER_SUCCESS,
    payload: voucherId,
});

export const deleteVoucherFail = error => ({
    type: DELETE_VOUCHER_FAIL,
    payload: error,
});

export const exportVoucher = data => ({
    type: EXPORT_VOUCHER,
    payload: data
});

export const exportVoucherSuccess = data => ({
    type: EXPORT_VOUCHER_SUCCESS,
    payload: data,
});

export const exportVoucherFail = error => ({
    type: EXPORT_VOUCHER_FAIL,
    payload: error,
});

//reset
export const resetVoucherAttachmentState = () => {
    return {
        type: RESET_VOUCHER_ATTACHMENT_STATE,
    }
}
export const resetVoucherState = () => {
    return {
        type: RESET_VOUCHER_STATE,
    }
}

